module.exports = __webpack_public_path__ + "img/Alabama.6459b83d.png";